import { css } from 'styled-components';

export const Button = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 60px;
  padding: 5px 20px;
  border: 2px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.background};
  color: ${(props) => props.theme.color};
  box-shadow: 0 3px 10px ${(props) => props.theme.shadow};
  border-radius: 8px;
  outline: none;
  transition: 0.2s all;
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  clip-path: polygon(
    20px 0px,
    calc(100% - 20px) 0px,
    100% 50%,
    calc(100% - 20px) 100%,
    20px 100%,
    0px 50%
  );
  cursor: pointer;

  &:hover {
    border: 2px solid ${(props) => props.theme.borderOnHover};
    background: ${(props) => props.theme.backgroundOnHover};
    color: ${(props) => props.theme.colorOnHover};

    ${(props) =>
      props.small &&
      css`
        border: 1px solid ${(props) => props.theme.borderOnHover};
      `}

    ${(props) =>
      props.tiny &&
      css`
        border: 1px solid ${(props) => props.theme.borderOnHover};
      `}
  }

  ${(props) =>
    props.square &&
    css`
      width: 60px;
    `}

  ${(props) =>
    props.small &&
    css`
      border: 1px solid ${(props) => props.theme.border};
      min-height: 46px;
      font-size: 20px;
      font-weight: 500;

      ${(props) =>
        props.square &&
        css`
          width: 52px;
          clip-path: polygon(
            13px 0px,
            calc(100% - 13px) 0px,
            100% 50%,
            calc(100% - 13px) 100%,
            13px 100%,
            0px 50%
          );

          ${(props) =>
            props.noMask &&
            css`
              width: 46px;
            `}
        `}
    `}

    ${(props) =>
    props.tiny &&
    css`
      border: 1px solid ${(props) => props.theme.border};
      min-height: 36px;
      font-size: 16px;
      font-weight: 500;
      padding: 5px 15px;

      ${(props) =>
        props.square &&
        css`
          width: 40px;
          clip-path: polygon(
            10px 0px,
            calc(100% - 10px) 0px,
            100% 50%,
            calc(100% - 10px) 100%,
            10px 100%,
            0px 50%
          );

          ${(props) =>
            props.noMask &&
            css`
              width: 36px;
            `}
        `}
    `}

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.35;
      cursor: default;
    `}

    ${(props) =>
    props.widthAuto &&
    css`
      width: auto;
    `}

    ${(props) =>
    props.noMask &&
    css`
      clip-path: none;
    `}

      ${(props) =>
    props.rounded &&
    css`
      border-radius: 100%;
    `}
`;
